import { createNewPopUpAtom } from "@/modules/editor-v2/Atoms";
import PopUp from "@/modules/ui-elements/PopUp";
import { css } from "@emotion/react";
import { useSetAtom } from "jotai";
import React, { useImperativeHandle } from "react";


export interface IPopUpV2Options {
    height: number;
    width: number;
    left: number;
    top: number;
    backdrop?: boolean;
    backdropOpacity?: number;
    closeOnBackdropClick?: boolean;
    onBackdropClick?: () => void;
}

export interface IPopUpV2Ref {
    open: (props: IPopUpV2Options) => void;
    close: () => void;
}

export interface IPopUpV2Props {
    children: React.ReactNode;
    header?: React.ReactNode;
    onBackdropClick?: () => void;
}

export default React.forwardRef<IPopUpV2Ref, IPopUpV2Props>(function PopUpV2(props,ref) {
    const [height, setHeight] = React.useState<number>(0);
    const [width, setWidth] = React.useState<number>(0);
    const [left, setLeft] = React.useState<number>(0);
    const [top, setTop] = React.useState<number>(0);
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [backdrop, setBackdrop] = React.useState<boolean>(false);
    const [backdropOpacity, setBackdropOpacity] = React.useState<number>(0.4);
    const [closeOnBackdropClick, setCloseOnBackdropClick] = React.useState<boolean>(true);

    const setCreateNewPopUp = useSetAtom(createNewPopUpAtom);

    const close = () => {
        setHeight(0);
        setWidth(0);
        setLeft(0);
        setTop(0);
        setIsOpen(false);
        setCreateNewPopUp(false);
        props?.onBackdropClick?.();
    }
    const open = (props: IPopUpV2Options) => {        
        setHeight(props?.height);
        setWidth(props?.width);
        setLeft(props?.left);
        setTop(props?.top);
        setBackdrop(props?.backdrop);
        setCloseOnBackdropClick(props?.closeOnBackdropClick ?? true);
        if(Number(props?.backdropOpacity) && props?.backdropOpacity !== 0) setBackdropOpacity(Math.min(Math.max(props?.backdropOpacity,0),1));
        setIsOpen(true);
    }

    const onBackdropClick = (closeOnBackdropClick)?close:()=>{};

    useImperativeHandle(ref, () => ({open,close}));

    return <React.Fragment>
        {backdrop && <div css={styles.backdrop(isOpen, backdropOpacity)} onClick={onBackdropClick} ></div>}
        <div css={styles.popUp(isOpen,top, left, height, width)}>
            {props?.header && <>
                <div className="header">
                    {props?.header}
                </div>
                <div className="divider"></div>
            </>}
            {props?.children}
        </div>
    </React.Fragment>
});

const styles = {
    backdrop:(visible:boolean,backdropOpacity:number)=>css`
        position:fixed;
        top:0px;
        left:0px;
        right:0px;
        bottom:0px;
        background:rgba(0, 0, 0, ${backdropOpacity});
        z-index:100000000000;
        height:100vh;
        width:100vw;
        transition:all 0.5s ease-in-out;
        overflow:hidden;
        visibility:${visible?"visible":"hidden"};
        opacity:${visible?"1":"0"};
    `,
    popUp: (visible,top, left, height, width)=>css`
        position:absolute;
        top:${top}px;
        left:${left}px;
        width: ${width}px;
        height:${height}px;
        z-index:1000000000000001;
        color:grey;
        background:white;
        visibility:${visible?"visible":"hidden"};
        opacity:${visible?"1":"0"};
        border-radius: 8px;
        overflow:auto;
        .header {
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            align-items:center;
            padding:10px 16px;
        }
        .header .left-section {
            font-family: 'Objectivity';
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            line-height: 140%;
            /* identical to box height, or 20px */

            display: flex;
            align-items: center;

            color: #262626;
        }
        .divider {
            border: 1px solid #EEEEEE;
        }

        .body {
            padding:10px 16px;
        }
        .footer {
            padding:10px 16px;
        }

    `
}